"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogoNameBrandName = exports.initializeSaola = exports.getColorByScore = exports.getParentRouteByRole = exports.getPlatformUrl = exports.getTenant = exports.badges = exports.getTags = void 0;
__exportStar(require("./filesTreeViewUtils"), exports);
__exportStar(require("./iframeFunctions"), exports);
__exportStar(require("./dateTimeUtils"), exports);
__exportStar(require("./stringUtils"), exports);
__exportStar(require("./testFunctions"), exports);
__exportStar(require("./constants"), exports);
var tags_1 = require("./tags");
Object.defineProperty(exports, "getTags", { enumerable: true, get: function () { return __importDefault(tags_1).default; } });
var badgesMapping_1 = require("./badgesMapping");
Object.defineProperty(exports, "badges", { enumerable: true, get: function () { return __importDefault(badgesMapping_1).default; } });
var getTenant_1 = require("./getTenant");
Object.defineProperty(exports, "getTenant", { enumerable: true, get: function () { return __importDefault(getTenant_1).default; } });
var getPlatformUrl_1 = require("./getPlatformUrl");
Object.defineProperty(exports, "getPlatformUrl", { enumerable: true, get: function () { return __importDefault(getPlatformUrl_1).default; } });
__exportStar(require("./functions"), exports);
__exportStar(require("./dateFormats"), exports);
var getParentRouteByRole_1 = require("./getParentRouteByRole");
Object.defineProperty(exports, "getParentRouteByRole", { enumerable: true, get: function () { return __importDefault(getParentRouteByRole_1).default; } });
__exportStar(require("./passwordValidation/passwordValidation"), exports);
__exportStar(require("./userAnalytics/initializeGainsight"), exports);
__exportStar(require("./programLanguages"), exports);
__exportStar(require("./mixpanelInstance"), exports);
var labs_1 = require("./labs");
Object.defineProperty(exports, "getColorByScore", { enumerable: true, get: function () { return __importDefault(labs_1).default; } });
var initSaola_1 = require("./userAnalytics/initSaola");
Object.defineProperty(exports, "initializeSaola", { enumerable: true, get: function () { return __importDefault(initSaola_1).default; } });
var customBrandNameLogoMapping_1 = require("./customBrandNameLogoMapping");
Object.defineProperty(exports, "getLogoNameBrandName", { enumerable: true, get: function () { return __importDefault(customBrandNameLogoMapping_1).default; } });
